/*eslint-disable*/
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import GridContainer from "components/Grid/GridContainer.js";
import ForwardIcon from "@material-ui/icons/Forward";
import EditIcon from "@material-ui/icons/Edit";

import PublishIcon from "@material-ui/icons/Publish";

import { AddBoxRounded, ArrowUpwardRounded } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.js";
import { features, language, offices, regions } from "config";
import { Grid, Typography } from "@material-ui/core";

import moment from "moment";
import {
    Row,
    Col,
    CardImg,
    Label,
    CardBody,
    Card,
    CardHeader,
    CardTitle,
    FormGroup,
    Input,
    FormText,
    Button,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
} from "reactstrap";

import FlatList from "flatlist-react";
import { makeStyles } from "@material-ui/core";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import GoogleMapsAutoComplete from "components/GoogleMapsAutoComplete";
import CustomDropDownPicker from "./CustomDropDownPicker";
import NoPhoneTenants from "views/PracticeAdmin/NoPhonePatients";

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        border: "5px solid",
        borderColor: "#399ddb",
        // borderBlockStartColor: "#ff0000",
        // borderBlockStart: "2px solid",
        // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        flexDirection: "column",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    Button: {
        width: 150,
        height: 40,
    },
    ImgContainer: {
        borderRadius: "50",
        height: "75%",
        width: "100%",
        aspectRatio: "16/9",
    },
    Card: {
        width: "50%",
        padding: 10,
        minWidth: 275,
        border: "1px solid",
        borderColor: "#399ddb",
        borderRadius: 30,
    },
    ImgCard: {
        width: "90%",
        border: "1px solid",
        borderColor: "#399ddb",
        borderRadius: 30,
    },
    PriceText: { margin: "20px0 15px", color: "#FF0000", fontSize: 32 },
    propType: {
        margin: "20px0 15px",
        fontSize: 16,
        color: "grey",
    },
    detialsSmokey: {
        width: "100%",
        alignContent: "center",
        flexDirection: "row",
        height: 25,
        backgroundColor: "#dcdcdc",
        display: "flex",
        flexDirection: "row",
    },
    detials: {
        width: "100%",
        alignContent: "center",
        flexDirection: "row",
        height: 25,
        display: "flex",
        flexDirection: "row",
    },
    CardHeader: {
        flexDirection: "column",
        fontSize: 18,
        fontWeight: "400",
        color: "#FF0000",
        display: "flex",
        margin: 15,
    },
    separator: {
        height: 1,
        width: "100%",
        backgroundColor: "#FF0000",
        alignSelf: "center",
        marginBottom: 15,
    },
    InfoDescriptionText: {
        width: "50%",
        color: "#003366",
        flexDirection: "row",
        fontSize: 15,
        fontWeight: "700",
        marginBottom: 0,
    },
    InfoText: {
        color: "#003366",
        flexDirection: "row",
        fontSize: 15,
        fontWeight: "300",
        marginBottom: 0,
    },
    radioButton: {
        marginLeft: 25,
        borderColor: "#009ad8",
        borderWidth: 2,
        height: 25,
        width: 25,
        marginTop: -4,
        marginRight: 5,
    },
    details: {
        display: "flex",
        flexDirection: "column",
    },
    input: {
        borderWidth: 2,
        borderColor: "#f00000",
        height: 40,
        backgroundColor: "white",
        fontSize: 16,
        paddingHorizontal: 10,
        paddingVertical: 8,
        borderRadius: 8,
        color: "grey",
        paddingRight: 30,
    },

    checkinput: {
        marginLeft: 25,
        borderColor: "#009ad8",
        borderWidth: 2,
        borderRadius: 8,
        height: 25,
        width: 25,
        marginTop: -0.5,
        marginRight: 5,
    },

    descriptioninput: {
        borderWidth: 400,
        borderColor: "#f00000",
        height: 250,
        backgroundColor: "white",
        fontSize: 16,
        paddingHorizontal: 10,
        paddingVertical: 8,
        borderRadius: 8,
        color: "grey",
        paddingRight: 30,
    },

    content: {
        flex: "1 0 auto",
    },
    cover: {
        width: 151,
    },
});

export default function CreateRegionModal() {
    const styles = useStyles();
    const dispatch = useDispatch();
    const { api } = useContext(FirebaseContext);
    const areaData = useSelector((state) => state.areaData);
    const { CreateEnquiry, fetchCoordsfromPlace, clearEnquiryErrors, addRegion, fetchCities, fetchSuburbs } = api;

    //useStates
    const [state, setState] = useState({
        regionId: "",
        regionName: "",
        shareBrokers: [],
        areas: [],
        selectedBranchName: "",
    });

    const [areaDetailsState, setAreaDetailsState] = useState({
        provinceName: "",
        cityName: "",
        suburbName: "",
    });

    const [isOpen, setIsOpen] = useState(false);
    const [brokerList, setBrokerList] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [suburbOption, setSuburbOption] = useState([])
    const [filterstate, setFilterState] = useState({
        startDate: "",
        endDate: "",
        sizeRangeMin: "",
        sizeRangeMax: "",
        type: "",
        Proptype: "",
        Broker: "",
    });

    //regex
    const phoneRegex =
        /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    const numberRegex =
        /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;
    const typeRegex = /^[a-zA-Z0-9\\,\\.\s]/g;

    //useSelectors
    const cities = useSelector((state) => state.citiesdata.city);
    const suburbs = useSelector((state) => state.citiesdata.suburb);
    const auth = useSelector((state) => state.auth);
    const brokers = useSelector((state) => state.brokers.users);
    const branchData = useSelector((state) => state.branchData.branches)

    // useEffect(() => {
    //     if(state.p24.provinceId) {
    //     dispatch(fetchCities(state.p24.provinceId))
    //     }
    //     if(state.p24.cityId) {
    //     dispatch(fetchSuburbs(state.p24.cityId))
    //     }
    // }, [state]);

    // useEffect(() => {
    //     if (cities?.length > 0) {
    //         const formattedCities = cities.map((city) => ({
    //             value: city.id,
    //             label: city.name
    //         }));
    //         setCityOptions(formattedCities);
    //     }

    // }, [cities]);

    // useEffect(() => {
    //     if (suburbs?.length > 0) {
    //         const formattedSuburbs = suburbs.map((sub) => ({
    //             value: sub.id,
    //             label: sub.name
    //         }));
    //         setSuburbOption(formattedSuburbs);
    //     }
    // }, [suburbs]);

    useEffect(() => {
        let arr = [];
        let arr2 = [];
        let arr3 = [];

        if (brokers) {
            console.log("Brokers:", brokers); // Log brokers to verify data
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id, // The broker ID (or name if preferred)
                        label: `${element.firstName} ${element.lastName}`, // Broker name
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Broker List:", arr); // Log broker list to verify population
        }

        if (branchData) {
            console.log("Branch Data:", branchData); // Log branch data to verify data
            for (let index = 0; index < branchData.length; index++) {
                const element = branchData[index];

                console.log(`adminHomeOffive: ${auth?.info?.profile?.adminHomeOffice}`);

                // Populate the list with all branches, remove brokerHomeOffice filter
                if (element.BranchName === auth?.info?.profile?.adminHomeOffice) {
                    arr2.push({
                        value: element.branchId, // The branch ID (or name if preferred)
                        label: `${element.BranchName}`, // Branch name
                    });
                }
            }
            setBranchList(arr2.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Branch List:", arr2); // Log branch list to verify population
        }

        if (areaData && areaData.areas) {
            for (let index = 0; index < areaData.areas.length; index++) {
                const element = areaData.areas[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.selectedBranchName === auth?.info?.profile?.adminHomeOffice) {
                    console.log(`match`);
                    arr3.push({
                        value: element.areaId,
                        label: element.areaName
                    });
                }
            }
            setAreaList(arr3.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Area List:", arr3.length > 0 ? arr3 : "No areas found"); // Log area list to verify population
        }

    }, [brokers, branchData, areaData]);

    useEffect(() => {
        if (areaDetailsState.provinceName && areaDetailsState.cityName && areaDetailsState.suburbName) {

            setState(prevState => ({
                ...prevState,
                areaName: concatLocationString(areaDetailsState.provinceName, areaDetailsState.cityName, areaDetailsState.suburbName),
            }));
        }
    }, [areaDetailsState]);

    const provinceOptions = [
        { value: '7', label: 'Eastern Cape' },
        { value: '3', label: 'Free State' },
        { value: '1', label: 'Gauteng' },
        { value: '2', label: 'KwaZulu Natal' },
        { value: '14', label: 'Limpopo' },
        { value: '5', label: 'Mpumalanga' },
        { value: '6', label: 'North West' },
        { value: '8', label: 'Northern Cape' },
        { value: '9', label: 'Western Cape' },
    ];

    const toggleTwo = () => setIsOpen(!isOpen);

    function concatLocationString(province, city, suburb) {

        if (province === "" && city === "" && suburb === "") {
            //alert("Please enter a province, city and suburb")
            return "";
        }

        let locationString = `South Africa, ${province}, ${city}, ${suburb}`;

        return (
            locationString
        );
    }

    const capitalizeFirstLetter = (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    };

    function generateLocationAbbr(city, suburb) {

        if (city === "" && suburb === "") {
            //alert("Please enter a city or suburb to generate an abbreviation.");
            return "";
        }

        let locationAbbr = `${capitalizeFirstLetter(city).slice(
            0,
            3
        )}${capitalizeFirstLetter(suburb).slice(0, 2)}`;

        return (
            locationAbbr
        );
    }

    const RenderProp24AreaInfoCard = () => {
        return (
            <Card
                style={{
                    backgroundColor: "#399ddb",
                    width: "95%",
                    height: "100%",
                    justifyContent: "center"
                }}
            >
                <CardHeader>
                    <CardTitle tag="h4" style={{ color: "white" }}>
                        Property24
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                        <GridContainer spacing={1}>
                            <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    Province:
                                </FormText>
                                <FormText color="red" tag="span">
                                    Required
                                </FormText>

                                <CustomDropDownPicker
                                    options={provinceOptions}
                                    isMulti={false}
                                    onChange={(selectedProv) => {
                                        updateDropDown("provinceId", selectedProv)
                                        let provinceObj = provinceOptions.find(prov => prov.value === selectedProv)
                                        updateAreaDetails("provinceName", provinceObj)
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    City:
                                </FormText>
                                <FormText color="red" tag="span">
                                    Required
                                </FormText>

                                <CustomDropDownPicker
                                    options={cityOptions}
                                    isMulti={false}
                                    onChange={(selectedCit) => {
                                        updateDropDown("cityId", selectedCit)
                                        let cityObj = cityOptions.find(city => city.value === selectedCit)
                                        updateAreaDetails("cityName", cityObj)
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    Suburb:
                                </FormText>
                                <FormText color="red" tag="span">
                                    Required
                                </FormText>

                                <CustomDropDownPicker
                                    options={suburbOption}
                                    isMulti={false}
                                    onChange={(selectedSub) => {
                                        updateDropDown("suburbId", selectedSub)
                                        let suburbObj = suburbOption.find(suburb => suburb.value === selectedSub)
                                        addGeoPoint(selectedSub);
                                        updateAreaDetails("suburbName", suburbObj)
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </CardBody>
            </Card>
        );
    };

    const RenderRegionInfoCard = () => {
        return (
            <Card
                style={{
                    backgroundColor: "#399ddb",
                    width: "95%",
                    height: "100%",
                    justifyContent: "center"
                }}
            >
                <CardHeader>
                    <CardTitle tag="h4" style={{ color: "white" }}>
                        Region Details
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                        <GridContainer spacing={1}>
                            <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    Region Name:
                                </FormText>
                                <FormText style={{ color: 'red', fontSize: '12px' }} tag="span">
                                    Required
                                </FormText>
                                <Input
                                    fullWidth
                                    type="text"
                                    style={{
                                        borderWidth: 2,
                                        borderColor: "#f00000",
                                        height: 35,
                                        backgroundColor: "white",
                                        fontSize: 16,
                                        paddingHorizontal: 10,
                                        paddingVertical: 8,
                                        borderRadius: 8,
                                        color: "grey",
                                        paddingRight: 30,
                                    }}
                                    placeholder="Region Name"
                                    onChange={(value) => {
                                        saveData("regionName", value.target.value);
                                    }}
                                    value={state.regionName}
                                />
                            </GridItem>

                            <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    Branch:
                                </FormText>
                                <FormText color="red" tag="span">
                                    Required
                                </FormText>

                                {branchList && branchList.length > 0 ? (
                                    <CustomDropDownPicker
                                        options={branchList}
                                        isMulti={false}
                                        value={state.selectedBranchName}
                                        onChange={(value) => {
                                            let selectedBranch = branchList.find(branch => branch.value === value);
                                            saveData("selectedBranchName", selectedBranch.label)
                                            console.log(`Branch Name: ${state.selectedBranchName}`)
                                        }}
                                    />
                                ) : (
                                    <FormText color="grey">No branches available</FormText> // Fallback if no branches
                                )}
                            </GridItem>
                            {/* <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    Brokers:
                                </FormText>
                                <FormText color="red" tag="span">
                                    Required
                                </FormText>

                                {brokerList && brokerList.length > 0 ? (
                                    <CustomDropDownPicker
                                        options={brokerList}
                                        isMulti={true}
                                        value={state.shareBrokers}
                                        onChange={(selectedBrokers) => {
                                            saveData("shareBrokers", selectedBrokers)
                                        }}
                                    />
                                ) : (
                                    <FormText color="grey">No brokers available</FormText> // Fallback if no brokers
                                )}
                            </GridItem> */}
                            <GridItem xs={12}>
                                <FormText color="white" tag="span">
                                    Areas:
                                </FormText>
                                <FormText color="red" tag="span">
                                    Required
                                </FormText>

                                {areaData && areaData.areas.length > 0 ? (
                                    <CustomDropDownPicker
                                        options={areaList}
                                        isMulti={true}
                                        value={state.areas}
                                        onChange={(selectedAreas) => {
                                            saveData("areas", selectedAreas)
                                        }}
                                    />
                                ) : (
                                    <FormText color="grey">No areas available</FormText> // Fallback if no areas
                                )}
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </CardBody>
            </Card>
        );
    };

    //functions
    const handleSubmit = async (regionData) => {
        if (
            state.regionName &&
            //state.shareBrokers.length > 0 &&
            state.selectedBranchName &&
            state.areas.length > 0
        ) {
            try {
                await dispatch(addRegion(regionData)); // assuming addRegion is a thunk
                alert("Region Created Successfully");
            } catch (error) {
                console.error("Failed to create region:", error);
                alert("Something went wrong while creating the region.");
            }
        } else {
            alert("No region name, brokers, branch or areas selected");
        }
    };

    const CreateRegion = () => {
        //Inriching Enquiry Data before sending it to the action
        // !DO NOT CHANGE WITHOUT PERMISSION FROM GAYNOR OR STEVEN!!!
        // ?last updated 25/04/2025
        let regionData = {
            regionName: state.regionName,
            shareBrokers: state.shareBrokers,
            selectedBranchName: state.selectedBranchName,
            areas: state.areas,
        };
        console.log("reionData", regionData);

        handleSubmit(regionData);
        toggleTwo();
        setState({
            regionId: "",
            regionName: "",
            shareBrokers: [],
            areas: [],
            selectedBranchName: "",
        });
    }

    const saveData = (location, data) => {
        setState({
            ...state,
            [location]: data,
        });
        console.log(`state: ${JSON.stringify(state)}`)
    };

    const saveProp24Data = (location, data) => {
        setState({
            ...state,
            p24: { [location]: data },
        });
        console.log(`Area state: ${JSON.stringify(state)}`)
    };

    const updateDropDown = (id, value) => {

        console.log('id', id)
        console.log('value', value)
        const updatedP24 = { ...state.p24, [id]: value };
        setState(prevState => ({
            ...prevState,
            p24: updatedP24
        }));
        console.log("updatedP24", updatedP24, `state`, state);
    };

    const updateAreaDetails = (location, data) => {

        setAreaDetailsState({
            ...areaDetailsState,
            [location]: data.label,
        });
        console.log(`areaDetailsState: ${JSON.stringify(areaDetailsState)}`)
    };

    const addGeoPoint = (suburbId) => {

        let suburb = suburbs.find(sub => sub.id === suburbId)
        console.log('geoPoint', suburb.geoPoint)

        const updatedP24 = { ...state.p24, ["geoPoint"]: suburb.geoPoint, suburbId: suburbId };
        setState(prevState => ({
            ...prevState,
            p24: updatedP24
        }));
        console.log("updatedP24", updatedP24, `state`, state);
    };

    const RenderModal = () => {
        return (
            <Modal isOpen={isOpen} toggle={toggleTwo} centered={true} size="lg">
                <ModalHeader>Create Region</ModalHeader>
                <ModalBody>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                        <GridContainer spacing={0}>
                            <GridItem lg={12}>{RenderRegionInfoCard()}</GridItem>
                            {/* <GridItem lg={6}>{RenderAreaInfoCard()}</GridItem> */}
                            {/* <GridItem lg={6}>{RenderProp24AreaInfoCard()}</GridItem> */}
                        </GridContainer>
                    </GridItem>
                </ModalBody>

                <ModalFooter>
                    <Button onClick={
                        CreateRegion
                    }>Create Region</Button>

                    <Button
                        style={{
                            backgroundColor: "#ff000f",
                            height: 45,
                        }}
                        onClick={toggleTwo}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    };

    return (
        <>
            <AddBoxRounded
                onClick={toggleTwo}
                style={{
                    color: "#ff000f",
                    alignItems: "right",
                    width: 50,
                    height: 50,
                    cursor: "pointer",
                }}
            />
            {RenderModal()}
        </>
    );
}
